import { Entity, System } from "ecsy";
import { Physics, Jump, Transform, Submerged, Cooldown } from "../components";
import { Game } from "../game";
import { applyImpulse } from "../box2dUtils";
import { addComponent } from "../utils";
import { CollisionCategory, PhysicsConstants } from "../constants";

export class JumpSystem extends System {
	private game: Game;

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	execute() {
		this.queries.jumpers.results.forEach(entity => {
			const jump = entity.getComponent(Jump);
			const cooldown = entity.getComponent(Cooldown);

			if (jump.isActive) {
				if (jump.progress >= jump.activePeriod) {
					this.endJump(entity);
					cooldown.restart();
				}
				else {
					jump.progress += PhysicsConstants.StepRate;
				}
			}
			else if (cooldown.done) {
				this.startJump(entity);
			}
		});
	}

	private startJump(entity: Entity) {
		const jump = entity.getMutableComponent(Jump);
		const physics = entity.getMutableComponent(Physics);
		const transform = entity.getComponent(Transform);

		jump.isActive = true;

		addComponent(entity, Submerged, { max: 0.5, collisionMask: CollisionCategory.Cell });

		physics.body.SetLinearDamping(0);
		const impulse = transform.direction.copy().scale(jump.jumpForce);
		applyImpulse(entity, impulse);
	}

	private endJump(entity: Entity) {
		const jump = entity.getMutableComponent(Jump);
		const physics = entity.getMutableComponent(Physics);
		const transform = entity.getComponent(Transform);

		jump.progress = 0;
		jump.isActive = false;

		const submerged = entity.getComponent(Submerged)
		if (submerged) {
			submerged.surfacing = true;
		}

		const counterImpulse = transform.direction.copy().negate().scale(jump.jumpForce);
		applyImpulse(entity, counterImpulse);
		physics.body.SetLinearDamping(PhysicsConstants.DefaultDamping);
	}
}

JumpSystem.queries = {
	jumpers: { components: [Physics, Jump, Cooldown] },
}
